import React from 'react'
import Home from '../pages/home'
import WizardStepOne from '../pages/wizard_steps/step_1'
import WizardStepTwo from '../pages/wizard_steps/step_2'
import WizardStepThree from '../pages/wizard_steps/step_3'
import WizardStepFour from '../pages/wizard_steps/step_4'
import WizardStepFive from '../pages/wizard_steps/step_5'
import Order from '../pages/order'
import PageNotFound from '../pages/errors/page_not_found'
import constants from '../constants'
import { Switch, Route } from 'react-router-dom'

class Routes extends React.Component{
  render() {
    return (
      <Switch>
        <Route exact path={constants.ROUTES.HOME} render={props => <WizardStepOne />} />
        <Route exact path={constants.ROUTES.STEP2} render={props => <WizardStepTwo />} />
        <Route exact path={constants.ROUTES.STEP3} render={props => <WizardStepThree />} />
        <Route exact path={constants.ROUTES.STEP4} render={props => <WizardStepFour />} />
        <Route exact path={constants.ROUTES.STEP5} render={props => <WizardStepFive />} />
        <Route exact path={constants.ROUTES.ORDER} render={props => <Order />} />
        <Route path="*" render={props => <PageNotFound />} />
      </Switch>
    )
  }
}

export default Routes;


// WEBPACK FOOTER //
// ./app/javascript/app/config/routes.jsx